const en = {
  wallet: "Wallet",
  subtitle: "Buy credits as you need them. No monthly package.",
  available: "Available",
  credits: "credits",
  creditsCount: "{n} credits",
  creditsCount_one: "{n} credit",
  purchased: "Purchased",
  spent: "Spent",
  lowBalance: "Low balance. Please add credit.",
  addCredit: "Add credit",
  addCreditDescription: "Pick a pack. Credits never expire and work across all your stores.",
  noPacks: "No credit packs are available right now.",
  noPacksDescription: "Contact support if you need more credits.",
  popular: "★ Most popular",
  bestValue: "💎 Best value",
  bonusLine: "+{bonus} bonus · {percent}%",
  totalCreditsSr: "{n} credits in total",
  selectPack: "Select the {label} pack",
  summary: "{price} = {credits} credits",
  summaryBonus: "{price} = {credits} credits (includes {bonus} bonus)",
  buy: "Buy credits",
  redirecting: "Opening secure checkout…",
  securePayment: "Secure payment by Stripe. Credits are added as soon as the payment is confirmed.",
  purchaseUnavailable: "Online purchase isn't available yet — contact support to add credits.",
  contactSupport: "Contact support",
  choosePack: "Choose a credit pack.",
  successTitle: "Payment received",
  successBody: "Your credits have been added to your wallet.",
  pendingTitle: "Payment is being confirmed…",
  pendingBody: "Your credits will appear here as soon as the payment clears. You can refresh this page in a moment.",
  problemBody: "We couldn't confirm this payment automatically. If you were charged, contact support and we'll sort it out.",
  cancelled: "Checkout was cancelled. No payment was taken.",
  thisMonth: "This month",
  planIncludes: "Your {plan} plan includes a free monthly allowance. After that, usage is paid with credits.",
  usagePrompts: "AI prompts",
  usageCallMinutes: "Voice call minutes",
  usageImages: "AI images",
  usedThisMonth: "{used} used this month",
  unlimitedFree: "Unlimited (free)",
  freeForEveryone: "Free for everyone right now — no credits are used.",
  pricing: "What things cost",
  costPrompt: "AI prompt",
  costPromptHint: "at Medium quality",
  costCall: "Voice call, per minute",
  costImage: "AI image",
  costTranslation: "AI translation, per item",
  free: "Free",
  levels: "Quality levels",
  levelsHint: "Prompts and calls cost more on higher quality levels.",
  level_low: "Low",
  level_medium: "Medium",
  level_high: "High",
  level_max: "Max",
  multiplier: "×{n}",
  notOnPlan: "Not on your plan",
  history: "History",
  historyDescription: "Your 50 most recent credit movements.",
  noHistory: "No credit activity yet",
  noHistoryDescription: "Purchases and AI usage will appear here.",
  colDescription: "Description",
  colCredits: "Credits",
  colBalance: "Balance after",
  kind_signup: "Welcome credits",
  kind_purchase: "Credit purchase",
  kind_spend: "AI usage",
  kind_refund: "Refund",
  kind_admin: "Adjustment by the platform",
  feature_prompt: "AI prompt",
  feature_call: "Voice call",
  feature_image: "AI image",
  feature_translation: "AI translation",
  chipLabel: "AI credits: {count}. Open wallet",
  chipLowLabel: "AI credits low: {count}. Add credits",
  bannerLow: "⚡ {n} credits left — top up to keep building",
  bannerLow_one: "⚡ {n} credit left — top up to keep building",
  bannerEmpty: "You're out of credits — add credits to continue",
  bannerCta: "Add credits →",
  dismiss: "Dismiss",
};

export default en;
